import { getApiUrl } from "@Helpers/api/buildUrl";

/**
 * Gets the subscription checkout session unique identifier.
 *
 * @param subscription The subscription object.
 */
export async function getSubscriptionCheckoutSessionApi(subscription) {
  const url = getApiUrl("settings/subscription");
  const config = { DISABLE_ERROR_INTERCEPTORS: true };
  const response = await axios.post(url, subscription, config);

  return response.data;
}

/**
 * Cancels the scheduled downgrade of the current subscription.
 */
export async function cancelDowngradeApi() {
  const url = getApiUrl("settings/subscription/scheduled");
  const response = await axios.delete(url);

  return response.data;
}

/**
 * Reactivate inactive or cancelled subscription.
 */
export async function reactiveSubscriptionApi() {
  const url = getApiUrl("settings/subscription");
  const response = await axios.patch(url);

  return response.data;
}

/**
 * Changes the current subscription to a new plan.
 * 
 * @param subscription The target subscription name.
 * @param interval The target subscription interval.
 * @param currency The target subscription currency.
 * @param type The target subscription type.
 * @param billing_type The billing type.
 * @param coupon The coupon code.
 */
export async function updateSubscriptionApi(subscription, interval, billing_type, currency, type, coupon) {
  const url = getApiUrl("settings/subscription");
  const data = { subscription, interval, billing_type, currency, type, coupon };
  const config = { DISABLE_ERROR_INTERCEPTORS: true };
  const response = await axios.put(url, data, config);

  return response.data;
}

/**
 * Cancels the current subscription.
 *
 * @param billing_type The billing type.
 * @param url The billable subscription endpoint (user, team or organization).
 */
export async function cancelSubscriptionApi(billing_type, url = getApiUrl("settings/subscription")) {
  const config = { DISABLE_ERROR_INTERCEPTORS: true, data: { billing_type } };
  const response = await axios.delete(url, config);

  return response.data;
}

/**
 * Calculates subscription proration for a plan/interval change.
 *
 * @param subscription The subscription form payload.
 */
export async function getProrationApi(subscription) {
  const url = getApiUrl("settings/subscription/prorate");
  const config = { DISABLE_ERROR_INTERCEPTORS: true };
  const response = await axios.post(url, subscription, config);

  return response.data;
}
